export enum StatusTarefaTerapeutica {
  Pendente = 1,
  Concluida = 2,
  Cancelada = 3
}

export enum TipoAnexoTarefa {
  Arquivo = 1,
  Link = 2
}

/** Material de apoio anexado a uma tarefa terapêutica. */
export interface AnexoTarefaDTO {
  id: number;
  tarefaId: number;
  tipo: TipoAnexoTarefa;
  nomeOriginal: string;
  url?: string | null;          // para Link
  contentType?: string | null;  // para Arquivo
  tamanhoBytes?: number | null;
}

/** Material de apoio anexado a um modelo. */
export interface AnexoModeloDTO {
  id: number;
  modeloId: number;
  tipo: TipoAnexoTarefa;
  nomeOriginal: string;
  url?: string | null;
  contentType?: string | null;
  tamanhoBytes?: number | null;
}

/** Modelo reutilizável de tarefa (biblioteca do psicólogo). */
export interface ModeloTarefaDTO {
  id: number;
  titulo: string;
  descricao: string;
  temAudio: boolean;
  audioDuracaoSegundos?: number | null;
  dataCriacao: string;
  anexos: AnexoModeloDTO[];
}

/** Payload de criação de tarefa terapêutica (POST /api/TarefaTerapeutica/adicionar). */
export interface CriarTarefaPostModel {
  clienteId: number;
  titulo: string;
  descricao: string;
  dataPrazo?: string | null;
}

/** DTO completo retornado pelos endpoints de tarefa. */
export interface TarefaTerapeuticaDTO {
  id: number;
  clienteId: number;
  usuarioId: number;
  titulo: string;
  descricao: string;
  dataPrazo?: string | null;
  status: StatusTarefaTerapeutica;
  dataCriacao: string;
  dataConclusao?: string | null;
  dataVisualizacao?: string | null;
  temAudioInstrucao: boolean;
  audioInstrucaoDuracaoSegundos?: number | null;
  respostaTexto?: string | null;
  dataResposta?: string | null;
  respostaTemAudio: boolean;
  respostaAudioDuracaoSegundos?: number | null;
  anexos: AnexoTarefaDTO[];
}

export interface PainelAcompanhamentoItem {
  clienteId: number;
  pacienteUsuarioId: number;
  nomeCliente: string;
  dataVinculo: string;
  dataUltimoCheckIn?: string | null;
  ultimoHumor?: number | null;
  checkInsUltimos7Dias: number;
  tarefasPendentes: number;
  tarefasAtrasadas: number;
  alertaHumorBaixo: boolean;
}

export interface ProximoAtendimentoResumo {
  id: number;
  dataHoraInicio: string;
  dataHoraFim: string;
  nomeServico?: string | null;
  nomeClinica?: string | null;
  statusConfirmacao: number;
}

export interface CheckInResumo {
  data: string;
  humor: number;
  ansiedade: number;
  sono: number;
  observacao?: string | null;
}

export interface IndicadoresCheckIn {
  quantidade: number;
  mediaHumor?: number | null;
  mediaAnsiedade?: number | null;
  mediaSono?: number | null;
  piorHumor?: number | null;
  dataUltimoCheckIn?: string | null;
}

export interface TarefaResumo {
  id: number;
  titulo: string;
  dataCriacao: string;
  dataPrazo?: string | null;
  dataConclusao?: string | null;
  status: StatusTarefaTerapeutica;
  temResposta: boolean;
}

export interface UltimaEvolucaoResumo {
  id: number;
  titulo: string;
  dataCriacao: string;
}

export interface ResumoPreSessao {
  clienteId: number;
  nomeCliente: string;
  clienteUsaEasyPaciente: boolean;
  proximoAtendimento?: ProximoAtendimentoResumo | null;
  ultimosCheckIns: CheckInResumo[];
  indicadores: IndicadoresCheckIn;
  tarefasPendentes: TarefaResumo[];
  tarefasConcluidasRecentes: TarefaResumo[];
  ultimaEvolucao?: UltimaEvolucaoResumo | null;
  alertas: string[];
}
